import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
import logo from "./images/loading.gif";
import logonotfound from './images/recordnotfound.png';
import Cookies from "universal-cookie";
import {DownloadTableExcel} from "react-export-table-to-excel";
import ReactToPdf from "react-to-pdf";
const ref = React.createRef(null);
const cookies = new Cookies();
const axios = require("axios");
export default class AdminLeavedetail_all extends Component {
    constructor(props) {
        super(props);
        this.state = {
        myitems: [],
        statustext:[],
        isLoaded: false,
        mylocation: [],
        islocation:false,
        locationcode:"01",
        locationname:"",
        ErrMsg:<img src={logo} alt="Error"/>,
        ErrMsg2:"",
        cMonth:new Date().getMonth(),
        cYear:new Date().getFullYear(),
        pYear:new Date().getFullYear(),
        Currentyear:"",
        Prevyear:"",
        ForYear:0,
        Period:"",
        input:{},
        eddiv:"none",
        DivClass: "ErrDiv",
        divxls:"none",
        apipath:"",
        leaveclass: "tdm"
        }
        this.handleLoadData=this.handleLoadData.bind(this);
        this.handleSelectChange=this.handleSelectChange.bind(this);
    }
    cur=(num)=> {
        let cnum=parseInt(num,0);
        if(num > 0)
            return Intl.NumberFormat("en-US", {maximumFractionDigits:2}).format(num);
        else
            return "-"
    }
    handleSelectChange=(e)=>{    
        this.setState({locationcode:e.target.value,locationname:e.nativeEvent.target[e.target.selectedIndex].text,myitems:[],eddiv:"none",divxls:'none'});
    }
    handleChange=(e)=>{
        this.setState({ForYear:e.target.value,Period:e.nativeEvent.target[e.target.selectedIndex].text,divxls:"none",eddiv:"none",myitems:[]});
    }
    handleLoadData(){
        document.body.style.cursor="wait";
        let input=this.state.input;
        input["forYear"]=this.state.ForYear;
        input["loc_id"]=this.state.locationcode;
        console.log(input);
        this.setState({ErrMsg:"",myitems:[],divxls:"none",eddiv:"none"});
        axios({
            method: 'post',
            url: this.state.apipath+"/index.php/user/get_leave_all/",
            data:input,
            headers: {'Content-Type': 'multipart/form-data'}
        })
        .then((response)=> {
            console.log(response.data);
            if(response.data === 0)
            {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<img src={logonotfound} alt="Not Found"/>,isLoaded:true,myitems:[], islocation:true,divxls:'none',eddiv:"block"});

//                this.setState({ErrMsg:<img src={logonotfound} alt="Not Found"/>,isLoaded:true, islocation:false,divxls:'none'});
            }
            else
            {
                document.body.style.cursor="default";
                this.setState({
                isLoaded: true,
                islocation:true,
                ErrMsg:"",
                divxls:"block",
                eddiv:"none",
                myitems: response.data
                });
            }   
        })
        .catch((response)=> {
            document.body.style.cursor="default";
            this.setState({ErrMsg:<img src={logonotfound} alt="Not Found"/>,myitems:[],isLoaded:true, islocation:true,divxls:'none',eddiv:"block"});
        });  
    }

    componentDidMount(){
        let cYear=this.state.cYear;
        let pYear=this.state.pYear;
        let Currentyear=this.state.Currentyear;
        let Prevyear=this.state.Prevyear;

        if(this.state.cMonth < 7)
        {
            Currentyear=(cYear - 1).toString() + " - " + cYear.toString();
            Prevyear=(cYear - 2).toString() + " - " + (cYear-1).toString();
            cYear=cYear-1;
            pYear=cYear-1;
        }
        else
        {
            Currentyear=cYear.toString() + " - " + (cYear + 1 ).toString();
            Prevyear=(cYear - 2).toString() + " - " + (cYear-1).toString();
            pYear=cYear-1;
        }
        this.setState({Currentyear,Prevyear,pYear,cYear,ForYear:cYear,Period:Currentyear,apipath:this.props.apipath });
            axios({
                method: 'post',
//                url: cookies.get("phpclass")+'/index.php/user/get_location/0',
                url: this.props.apipath+'/index.php/user/get_location/0',
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then((response)=> {
                 if(response.data === 2)
                {
                    document.body.style.cursor="default";
                    this.setState({ErrMsg:<img src={logo} alt="Error"/>,islocation:false,isLoaded:true,eddiv:"block"});
                }
                else
                {
                    document.body.style.cursor="default";
                    this.setState({
                    locationcode: response.data[0]["l_code"],
                    islocation: true,
                    isLoaded:true,
                    ErrMsg:"",
                    eddiv:"",
                    mylocation: response.data,
                    locationname:response.data[0]["location"]
                    })
                }
            })
            .catch(()=> {
                document.body.style.cursor="default";
                this.setState({ErrMsg:<img src={logo} alt="Error"/>});
            });    
    }
    render(){
        let isLoaded = this.state.isLoaded;
        let islocation=this.state.islocation;
        let items = this.state.myitems;    
        let litems = this.state.mylocation;
        let fileName=this.state.locationname+".pdf";
{/*}        else if(isLoaded && !islocation)
        {
            return(
            <div className="center">
               {this.state.ErrMsg}
            </div>
            );
        }*/}
        if (!isLoaded && !islocation) 
        {
            return(
              <div className="center">
                {this.state.ErrMsg}
              </div>
            );
        } 
        else if((isLoaded && islocation)) //|| (isLoaded && !islocation))
        {
            return(
            <div width="100%" textAlign="center" >
            <br></br>
            <div className="inner-profile33-all" >
            <span className="box-title" >Leave Balances</span>
            <div className="inner-profile2" >
            <label style={{paddingLeft:2,width:"85px"}}>Location <font style={{color:"red"}}>*</font></label>
            <select id="location" name="location" style={{height:25,width:150,borderRadius:0}} onChange={this.handleSelectChange} >
                {litems.map((result,i)=>{
                return(
                    <option value={result.l_code} key={i}  >{result.location}</option>
                );
                })}
            </select>
            <br></br>
            <label style={{paddingLeft:2,width:"85px"}}>Year: <font style={{color:"red"}}>*</font></label>
            <select id="year" name="year" style={{height:25,width:150,borderRadius:0}} onChange={this.handleChange} >
                <option value={this.state.cYear} key={1} >{this.state.Currentyear}</option>
                <option value={this.state.pYear} key={2} >{this.state.Prevyear}</option>
            </select>
            <button type="submit" style={{background: "linear-gradient(to bottom , #ffffff 0%, white 100%)"}} onClick={this.handleLoadData}>Submit </button>
            <br></br>
            </div>
            <div style={{textAlign:"center",width:"100%",display:this.state.divxls}}  ref={ref} >
            <div style={{textAlign:"center",width:"100%",display:this.state.divxls}}>
            <h5>{this.state.locationname}  </h5>
            <h6>For {this.state.Period}</h6>
            </div>
            <table style={{width:"100%",paddingLeft:"1%",paddingTop:"10px"}} id="table-to-xls"  >
            <thead>
                <tr className="tr" >
                    <th style={{backgroundColor:"Gainsboro",borderBottom:"none"}} className="thl" scope="col"></th>
                    <th style={{backgroundColor:"Gainsboro",borderBottom:"none"}} className="thl" scope="col"></th>
                    <th style={{backgroundColor:"Gainsboro",borderBottom:"none"}} className="thn" scope="col"></th>
                    <th style={{backgroundColor:"BurlyWood",borderBottom:"none"}} className="thl" scope="col" >Annual</th>
                    <th style={{backgroundColor:"goldenrod"}} className="thl" scope="col" colSpan={3}>Allocation for the year</th>
                    <th style={{backgroundColor:"LightCoral",borderBottom:"none"}} className="thl" scope="col" >Annual</th>

                    <th style={{backgroundColor:"lightblue"}} className="thl" scope="col" colSpan={3}>Balance</th>
                </tr>

                <tr className="tr">
                    <th style={{backgroundColor:"Gainsboro",borderTop:"none"}} className="thl" scope="col">Sr#</th>
                    <th style={{backgroundColor:"Gainsboro",borderTop:"none"}} className="thl" scope="col">ID</th>
                    <th style={{backgroundColor:"Gainsboro",borderTop:"none"}} className="thn" scope="col">Employee Name</th>
                    <th style={{backgroundColor:"BurlyWood",borderTop:"none"}} className="thl" scope="col">B/F</th>
                    <th style={{backgroundColor:"goldenrod"}} className="thl" scope="col">Annual</th>
                    <th style={{backgroundColor:"goldenrod"}} className="thl" scope="col">Casual</th>
                    <th style={{backgroundColor:"goldenrod"}} className="thl" scope="col">Sick</th>
                    <th style={{backgroundColor:"LightCoral",borderTop:"none"}} className="thl" scope="col">Encash</th>
                    <th style={{backgroundColor:"lightblue"}} className="thl" scope="col">Annual</th>
                    <th style={{backgroundColor:"lightblue"}} className="thl" scope="col">Casual</th>
                    <th style={{backgroundColor:"lightblue"}} className="thl" scope="col">Sick</th>
                </tr>
            </thead>
            <tbody>
            {
                items.map((result ,i) => {
                let attclass="tdml";
                return(
                    <tr className="trc" key={i}>
                        <td style={{backgroundColor:"Gainsboro",borderTop:"none"}} className={attclass}>{i+1}</td>
                        <td style={{backgroundColor:"Gainsboro",borderTop:"none"}} className={attclass}>{result.EMP_ID}</td>
                        <td style={{backgroundColor:"Gainsboro",borderTop:"none"}} className="tdmn" >{result.NAME}</td>
                        <td style={{backgroundColor:"BurlyWood",borderTop:"none"}} className={attclass}>{this.cur(result.BF_ANNUAL)}</td>
                        <td style={{backgroundColor:"goldenrod"}} className={attclass}>{this.cur(result.ANNUAL)}</td>
                        <td style={{backgroundColor:"goldenrod"}} className={attclass}>{this.cur(result.CASUAL)}</td>
                        <td style={{backgroundColor:"goldenrod"}} className={attclass}>{this.cur(result.SICK)}</td>
                        <td style={{backgroundColor:"LightCoral"}} className={attclass}>{this.cur(result.E_ANNUAL)}</td>

                        <td style={{backgroundColor:"lightblue"}} className={attclass}>{this.cur(result.B_ANNUAL)}</td>
                        <td style={{backgroundColor:"lightblue"}} className={attclass}>{this.cur(result.B_CASUAL)}</td>
                        <td style={{backgroundColor:"lightblue"}} className={attclass}>{this.cur(result.B_SICK)}</td>

                    </tr>
                );
                })
            }
            </tbody>
        </table>
        </div>
        <div style={{textAlign:"center",paddingTop:5,display:this.state.divxls}} >
            <DownloadTableExcel
                filename={this.state.locationname+this.state.departmentname}
                sheet="users"
                currentTableRef={ref.current}
                >
                <button style={{background:"linear-gradient(to bottom , #ffffff 0%, black 100%)"}}> Export excel </button>
            </DownloadTableExcel>
            <ReactToPdf targetRef={ref} filename={fileName} x={10} scale={0.8}>
                  {({toPdf}) => (
                    <button onClick={toPdf} style={{background:"linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Download pdf</button>
                  )}
            </ReactToPdf>
        </div>
        </div>
        <div style={{width:"80%",marginTop:"25px",textAlign:"center" }} >
        {this.state.ErrMsg}
        </div>
        </div>    
        );
    }
}}
